import { defineLocale } from "../../registry";

const places = defineLocale({
  ru: {
    "places.title": "Места",
    "places.search.label": "Найти место в справочнике",
    "places.search.placeholder": "Страна или город",
    "places.search.submit": "Найти",
    "places.search.tooShort": "Введите не менее 2 символов",
    "places.search.results": "Результаты поиска",
    "places.search.empty": "Ничего не найдено",
    "places.search.add": "Добавить",
    "places.search.addAria": "Добавить место: {name}",
    "places.search.added": "Уже добавлено",
    "places.search.unsupported": "Этот тип места консоль не поддерживает",
    "places.kind.country": "Страна",
    "places.kind.city": "Город",
    "places.kind.unknown": "Неизвестный тип",
    "places.list.title": "Места Pick",
    "places.list.empty": "Мест нет — это допустимо",
    "places.list.primary": "Основное",
    "places.list.makePrimary": "Сделать основным",
    "places.list.makePrimaryAria": "Сделать основным: {name}",
    "places.list.moveUp": "Выше",
    "places.list.moveUpAria": "Поднять выше: {name}",
    "places.list.moveDown": "Ниже",
    "places.list.moveDownAria": "Опустить ниже: {name}",
    "places.list.remove": "Убрать",
    "places.list.removeAria": "Убрать место: {name}",
    "places.list.limit": "Достигнут предел мест: {max}",
    "places.issue.generic": "Сервер не принял эти места",
    "places.issue.city_unknown": "Города нет в справочнике",
    "places.issue.country_unknown": "Страны нет в справочнике",
    "places.issue.duplicate_place": "Это место добавлено дважды",
    "places.issue.primary_missing": "Не выбрано основное место",
    "places.issue.duplicate_primary": "Основным может быть только одно место",
    "places.issue.too_many_places": "Слишком много мест",
  },
  en: {
    "places.title": "Places",
    "places.search.label": "Search the place directory",
    "places.search.placeholder": "Country or city",
    "places.search.submit": "Search",
    "places.search.tooShort": "Type at least 2 characters",
    "places.search.results": "Search results",
    "places.search.empty": "No places found",
    "places.search.add": "Add",
    "places.search.addAria": "Add place: {name}",
    "places.search.added": "Already added",
    "places.search.unsupported": "The console does not support this place type",
    "places.kind.country": "Country",
    "places.kind.city": "City",
    "places.kind.unknown": "Unknown type",
    "places.list.title": "Pick places",
    "places.list.empty": "No places — this is allowed",
    "places.list.primary": "Primary",
    "places.list.makePrimary": "Make primary",
    "places.list.makePrimaryAria": "Make primary: {name}",
    "places.list.moveUp": "Up",
    "places.list.moveUpAria": "Move up: {name}",
    "places.list.moveDown": "Down",
    "places.list.moveDownAria": "Move down: {name}",
    "places.list.remove": "Remove",
    "places.list.removeAria": "Remove place: {name}",
    "places.list.limit": "Place limit reached: {max}",
    "places.issue.generic": "The server did not accept these places",
    "places.issue.city_unknown": "The city is not in the directory",
    "places.issue.country_unknown": "The country is not in the directory",
    "places.issue.duplicate_place": "This place is added twice",
    "places.issue.primary_missing": "No primary place is chosen",
    "places.issue.duplicate_primary": "Only one place can be primary",
    "places.issue.too_many_places": "Too many places",
  },
});

export default places;
